export const QR_LOGIN_API = "/qr-login";
export const QR_REPORT_API = "/qr-code";
export const QR_INFO = "/thong-tin";
